export { ReactComponent as Eye } from './svgs/eye.svg';
